export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',
    REGISTER_CLEAR: 'USERS_REGISTER_CLEAR',

    RESET_REQUEST: 'USERS_RESET_REQUEST',
    RESET_SUCCESS: 'USERS_RESET_SUCCESS',
    RESET_FAILURE: 'USERS_RESET_FAILURE',
    RESET_CLEAR: 'USERS_RESET_CLEAR',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT',

    GETACCOUNT_REQUEST: 'USERS_GETACCOUNT_REQUEST',
    GETACCOUNT_SUCCESS: 'USERS_GETACCOUNT_SUCCESS',
    GETACCOUNT_FAILURE: 'USERS_GETACCOUNT_FAILURE',

    EDITACCOUNT_SETUP: 'USERS_EDITACCOUNT_SETUP',
    EDITACCOUNT_SET: 'USERS_EDITACCOUNT_SET',

    PATCHACCOUNT_REQUEST: 'USERS_PATCHACCOUNT_REQUEST',
    PATCHACCOUNT_SUCCESS: 'USERS_PATCHACCOUNT_SUCCESS',
    PATCHACCOUNT_FAILURE: 'USERS_PATCHACCOUNT_FAILURE',
};
